import { Injectable } from '@angular/core';

@Injectable()
export class ValuesListService {

  public PRODELT_UNDEFINED = 0;
  public PRODELT_ISOTHERM = 1;
  public PRODELT_NOT_ISOTHERM = 2;

  constructor() { }

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/shared/values-list.service.ts